<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog id="dialogAcessos" titulo="Acessos" tamanho="lg" ref="dialog" :modal="propView == 'modal'">
        <form class="text-left">

          <div class="row">
            <div class="col-sm-12 text-center">

              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="atualizarItens()"
                style="margin-bottom:20px"
              >Atualizar</button>

              <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="desconectar()"
                style="margin-bottom:20px;margin-left:10px"
              >Desconectar</button>
              
              <div class="rowLista">
                <div class="list-group-item list-group-item-dark text-left">
                  <div class="row">
                    <div class="col">
                      <h6 style="margin-top:9px"><small>Entrou</small></h6>
                    </div>
                    <div class="col">
                      <h6 style="margin-top:9px"><small>Atualizou</small></h6>
                    </div>
                    <div class="col">
                      <h6 style="margin-top:9px"><small>Servidor</small></h6>
                      
                    </div>
                    <div class="col text-center">
                      <h6 style="margin-top:9px"><small>Canal</small></h6>
                    </div>
                    <div class="col text-right">
                      <h6 style="margin-top:9px"><small>IP</small></h6>
                    </div>
                  </div>
                </div>
                <div
                  class="list-group-item list-group-item-action text-left"
                  v-for="item in itens"
                  :key="item.id"
                  :item="item"
                >
                  <div class="row">
                    <div class="col">
                      <h6 style="margin-top:9px"><small>{{ formatDateTime(item.dataEntrada) }}</small></h6>
                    </div>
                    <div class="col">
                      <h6 style="margin-top:9px"><small>{{ formatDateTime(item.dataRenovou) }}</small></h6>
                    </div>
                    <div class="col">
                      <h6 style="margin-top:9px"><small>{{ $global.servidores_sip()[item.evento.servidorTipo + "_" + item.evento.servidor].nome }}</small></h6>
                    </div>
                    <div class="col text-center">
                      <h6 style="margin-top:9px"><small>{{ item.canal }}</small></h6>
                    </div>
                    <div class="col text-right">
                      <h6 style="margin-top:9px"><small>{{ item.ipClienteAtual }}</small></h6>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
        </form>

        <template v-slot:rodape>
          <button
            type="button"
            class="btn btn-secondary"
            v-if="view == 'modal'"
            data-dismiss="modal"
          >Fechar</button>
        </template>

      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import Dialog from "../components/Dialog.vue";

export default {
  name: "ListSessaoViewDetalhes",
  components: { Dialog },
  props: {
    propMeusDados: { type: Boolean, default: false },
    propView: { type: String, default: "modal" },
    propVencimento: { type: Boolean, default: true },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    atualizarItens()
    {
      this.carregarItens(this.item.evento,this.item.usuario);
    },
    async carregarItens(evento,usuarioEmail) {

      this.itens = [];

      this.item.evento = evento;
      this.item.usuario = usuarioEmail;
      
      const response = await api.get("/sessaoView/usuario?evento=" + evento + "&usuario=" + usuarioEmail);

      //* Verifica se econtrou
      if (response.data.erro == false) {
        this.itens = response.data.itens;
      }

    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
    async desconectar()
    {
      var desconectar = confirm("Deseja desconectar todas as sessões deste cliente neste evento ?");

      if (desconectar == true) {
        await api.post("/sessaoView/desconectar/" + this.item.evento + "/" + this.item.usuario,{});
        this.atualizarItens();
      }

    }
  },
  mounted() {
    
    this.view = this.propView;

  },
  data: function () {
    return {
      item:{evento:"",usuario:""},
      itens:[],
      view: "",
      mensagem: "",
    };
  },
};
</script>

<style></style>
